<template>
	<div class="flexer">
		<div class="select_wrapper" v-if="this.options.length > 0">
			<select class="styled_select narrow" v-model="selected_option" v-on:change="changeOption">
				<option v-for="option in this.options" :value="option.id">{{ option.values.name }} {{ option.values.price > 0 ? '(+£' + option.values.price + ')' : '' }}</option>
			</select>
		</div>
		<template v-if="type=='package_addon' || type=='build_your_own'">
			<template v-if="this.inBasket">
				<button v-on:click="removeActivity" type="button" class="button medium thin solid minus remove" :style="'--accent:' + this.accent">Remove</button>
			</template>
			<template v-else>
				<button v-on:click="addActivity" type="button" class="button medium thin solid plus" :style="'--accent:' + this.accent">Add</button>
			</template>
		</template>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'type',
		'package_id',
		'destination_id',
		'activity_id',
		'options',
		'accent'
	],

	data: () => {
		return {
			store_type: '',
			store_id: 0,
			selected_option: 0,
		}
	},

	computed: {
		this_item () {
			return this.$store.getters.getItem(this.store_id, this.store_type);
		},
		inBasket () {
			return this.this_item && this.this_item.activities.find(items => items.id == this.activity_id) ? true : false;
		}
	},

	watch: {
		inBasket: function(value) {
			if(!value) { this.selected_option = 0; this.setToFirstOption(); }
		}
	},

	created() {
		this.store_type = this.type=='build_your_own' ? 'destination' : 'package';
		this.store_id = this.type=='build_your_own' ? this.destination_id : this.package_id;
	},

	mounted() {
		if (this.inBasket) {
			var activity = this.this_item.activities.find(items => items.id == this.activity_id);
			if(activity && activity.option_id > 0) {
				this.selected_option = activity.option_id;
			}else{
				this.selected_option = 0;
			}
		}
		this.setToFirstOption();
	},

	methods: {

		setToFirstOption: function() {
			if (this.selected_option == 0 && this.options.length > 0) {
				this.selected_option = this.options[0].id;
			}
		},

		changeOption: function() {
			if (this.type=='package_included' || this.inBasket) {
				this.addActivity();
			}

		},

		addActivity: function(){
			this.$store.commit({
				type: 'addActivityToStore',
				store_type: this.store_type,
				store_id: parseInt(this.store_id),
				activity_id: parseInt(this.activity_id),
				option_id: parseInt(this.selected_option)
			});
		},

		removeActivity: function(){
			this.$store.commit({
				type: 'removeActivityFromStore',
				store_type: this.store_type,
				store_id: parseInt(this.store_id),
				activity_id: parseInt(this.activity_id),
			});
		}
	}
};
</script>